import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface MonthlyData {
  month: string;
  amount: number;
}

export interface PropertyYearlyMetrics {
  monthly_income: MonthlyData[];
  monthly_expenses: MonthlyData[];
  monthly_profit: MonthlyData[];
  accumulated_profit: MonthlyData[];
  total_income: number;
  total_expenses: number;
  net_profit: number;
}

interface UsePropertyYearlyMetricsProps {
  year: number;
  propertyIds?: string[];
  organizationIds?: string[];
}

export const usePropertyYearlyMetrics = ({
  year,
  propertyIds,
  organizationIds,
}: UsePropertyYearlyMetricsProps) => {
  return useQuery({
    queryKey: ["property-yearly-metrics", year, propertyIds, organizationIds],
    queryFn: async () => {
      const { data, error } = await supabase.rpc("get_property_yearly_metrics", {
        p_year: year,
        p_property_ids: propertyIds?.length ? propertyIds : null,
        p_organization_ids: organizationIds?.length ? organizationIds : null,
      });
      
      if (error) throw error;
      return data as unknown as PropertyYearlyMetrics;
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};

export default usePropertyYearlyMetrics;
